var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.046 68.627c-.543-1.092-8.913-17.833-17.477-19.939-2.887-.648-5.2-.076-5.2-.076-3.179.923-5.496 3.678-6.4 6.083-1.81 5.355.973 9.438 3.692 13.264 5.438 7.65 10.716 15.205 16.154 22.856 1.856 2.54 3.743 5.208 6.726 6.242 3.88 1.357 8.313-.558 10.952-3.665 2.768-3.139 4.093-7.148 5.45-11.028l2.423-6.734c2.777-7.504 5.844-14.942 9.07-22.285s6.613-14.587 10.289-21.768 7.383-14.232 11.507-21.251c1.063-1.763 1.998-3.494 3.061-5.257.194-.32 1.514-2.147 1.29-2.5-.224-.354-1.992.765-2.377.86-3.277 1.63-6.428 3.773-9.257 6.11-5.757 4.832-10.456 10.63-14.963 16.654a288.234 288.234 0 0 0-24.94 42.434z",
    fill: "#464646",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1c26367a5a9464f0e8007e67d98817ae.svg";
export { ForwardRef as ReactComponent };